import moment from 'moment';

export function getLabelFromDateRange(dates: Date[], targetDateStr: string) {
  const language: string = (localStorage.getItem('lang') || 'en').replace(/"/g, '').trim();
  const [startDateStr, endDateStr] = dates;
  const startDate = moment(startDateStr, 'YYYY-MM-DD');
  const endDate = moment(endDateStr, 'YYYY-MM-DD');
  const targetDate = moment(targetDateStr, 'YYYY-MM-DD').locale(language);

  const isSameYear = startDate.year() === endDate.year();
  const diffInDays = endDate.diff(startDate, 'days');
  const diffInMonths = endDate.diff(startDate, 'months');

  // Case 1: <= 1 month
  if (diffInDays <= 31) {
    if (!isSameYear) {
      return targetDate.format(language === 'vi' ? 'DD MMM YYYY' : 'MMM DD, YYYY');
    }
    return targetDate.format(language === 'vi' ? 'DD MMM' : 'MMM DD');
  }

  // Case 2: > 1 month && <= 1 year
  if (diffInMonths <= 12) {
    return targetDate.format('MMM') + (!isSameYear ? ` ${targetDate.year()}` : '');
  }

  // Case 3: > 1 year
  return targetDate.year().toString();
}
